module.exports = __webpack_public_path__ + "img/mine.6eb872af.png";